import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { get as _get, isEmpty as _isEmpty } from "lodash";
import OutsideClickHandler from "react-outside-click-handler";
import {
    ArrowBackSettings,
    ClosePopup,
    IconNoStar,
    IconNoStaredMessage,
    IconStaredArrow,
    IconStaredMenu,
    Menu,
    UnStar
} from "../../../assets/images";
import "./StarredMessages.scss";
import ProfileImage from "../Common/ProfileImage";
import { downloadMediaFile, getActiveConversationMessageByMsgId, getMessageFromHistoryById, getMsgStatusEle, getReplyMessageFormat, isGroupChat, isSingleChat, offlineReplyHandle } from "../../../Helpers/Chat/ChatHelper";
import { jumpToMessage } from "../../../Helpers/Chat/JumpToMessage";
import { initialNameHandle, formatDisplayName, getUserDetails, isLocalUser } from "../../../Helpers/Chat/User";
import { getGroupData } from "../../../Helpers/Chat/Group";
import { getMessageTimeElement } from "../../../Helpers/UIElements";
import { callOriginStrMsgAction, RemoveAllStarredMessages } from "../../../Actions/StarredAction";
import SDK from "../../SDK";
import Store from "../../../Store";
import { RemoveAllStarredMessagesHistory } from "../../../Actions/ChatHistory";
import TextComponent from "../Conversation/Templates/Chat/TextComponent";
import ImageComponent from "../Conversation/Templates/Chat/ImageComponent";
import VideoComponent from "../Conversation/Templates/Chat/VideoComponent";
import AudioComponent from "../Conversation/Templates/Chat/AudioComponent";
import DocumentComponent from "../Conversation/Templates/Chat/DocumentComponent";
import ContactComponent from "../Conversation/Templates/Chat/ContactComponent";
import LocationComponent from "../Conversation/Templates/Chat/LocationComponent";
import Modal from "../Common/Modal";
import { toast } from "react-toastify";
import { blockOfflineAction, isAppOnline } from "../../../Helpers/Utility";
import { ReplyMessageAction } from "../../../Actions/MessageActions";
import ReplyMessageBlock from "../../WebChat/Conversation/Templates/Common/ReplyMessage";
import MeetComponent from "../Conversation/Templates/Chat/MeetComponent";
import { convertLocalDateForStarredMessage } from "../WebChatTimeStamp";
import PropTypes from "prop-types";
import { ChannelInvite } from "../../../channels/conversation/ChannelMessage/components";
import Button from "../../../ui/Button";

const StarredMessages = (props = {}) => {
    const [unstarDrop, setUnstarDrop] = useState(false);
    const [unstarConfirm, setUnstarConfirm] = useState(false);
    const [dropDownStatus, setDropDownStatus] = useState(-1);
    const [prevDropDownStatus, setPrevDropDownStatus] = useState('');
    const [dropDownOpen, setDropDownOpen] = useState(false);
    const { handleBackToSetting, featureStateData: { isStarMessageEnabled = false } = {}, handleShowCallScreen } = props;
    const { data: starData = [] } = useSelector((state) => state.starredMessages);
    const chatConversation = useSelector((state) => state.chatConversationHistory) || {};
    const { data: chatHistoreData = {} } = chatConversation;
    const [starredMessages, setStarredMessages] = useState([]);
    const [seletedData, setSeletedData] = useState({});
    const { starProfileData } = useSelector((state) => state.rosterData);

    useEffect(() => {
        const sortedData = starData.sort((x, y) => new Date(y.favDate).getTime() - new Date(x.favDate).getTime());
        const addReplyIsEsisting = sortedData.map((ele) => {
            if (_get(ele, "msgBody.replyTo", "") !== "") {
                return {
                    ...ele,
                    isReply: true
                }
            }
            else {
                return {
                    ...ele,
                    isReply: false
                }
            }
        })
        setStarredMessages(addReplyIsEsisting);
        return (() => {
            setSeletedData({});
        })
    }, [starData, starProfileData]);

    useEffect(() => {
        if (Object.keys(chatHistoreData).length !== 0) {
            if (Object.keys(seletedData).length !== 0) {
                if (Object.keys(chatHistoreData[seletedData.fromUserId]?.messages)?.length !== 0) {
                    setTimeout(() => {
                        Store.dispatch(callOriginStrMsgAction(
                            {
                                fromPage: "starPage",
                                callOriginStrMsg: true,
                                callOriginStrMsgId: seletedData,
                            }
                        ));
                        setSeletedData({});
                    }, 500);
                }
            }
        }
    }, [chatHistoreData]);

    const getSenderName = (data) => {
        let messageFrom = data?.publisherId;
        if (!isLocalUser(messageFrom)) {
            const { nameToDisplay = "-" } = formatDisplayName(messageFrom) || {};
            return nameToDisplay;
        }
        return "You"
    };

    const getReceiverName = (data) => {
        if (isGroupChat(data?.chatType)) {
            const { groupName = "" } = getGroupData(data?.fromUserId) || {};
            return groupName || "-";
        }
        if (isSingleChat(data?.chatType)) {
            const { nameToDisplay = "-" } = formatDisplayName(data?.fromUserId) || {};
            if (data?.fromUserId === data?.publisherId) {
                return "You"
            }
            return nameToDisplay;
        }
    }

    const isUserInactive = (userId) => {
        if (!userId || isLocalUser(userId)) return false;
        return Boolean(getUserDetails(userId)?.isAdminBlocked);
    };

    const handleUnStarall = () => {
        setUnstarDrop(false);
        if (blockOfflineAction()) return;
        setUnstarConfirm(true);
    };

    const handleUnStarallAction = async () => {
        setUnstarConfirm(false);
        if (blockOfflineAction()) return;
        SDK.removeAllFavouriteMessages();
        Store.dispatch(RemoveAllStarredMessages());
        Store.dispatch(RemoveAllStarredMessagesHistory(starredMessages));
    };

    const getParentClass = (data) => (isLocalUser(data.publisherId) ? "starred-own" : "Starred-others");

    const getChildClass = (data) => (isLocalUser(data.publisherId) ? "receiver" : "sender");

    const singleFileClass = (data) =>
        (data.msgType === "video" || data.msgType === "image") && data?.msgBody?.media?.caption === "" ? " singleFile" : "";

    const singleFileClassLocation = (data) =>
        data.msgType === "location" ? " singleFile location-message image-block" : "";

    const captionFinderClass = (data) =>
        ((data.msgType === "image" || data.msgType === "video" || data.msgType === "file") && data?.msgBody?.media?.caption !== "") ? " has-caption " : "";

    const getProfileElement = (data) => {
        const userDetails = getUserDetails(data.publisherId || data.fromUserId);
        const iniTail = initialNameHandle(userDetails);
        return (
            <div className="senderDetails">
                <span className="starred-time">{convertLocalDateForStarredMessage(data.createdAt)}</span>
                <div className="sender-info">
                    <span className="sender-image">
                        <ProfileImage
                            name={iniTail}
                            imageToken={(userDetails.thumbImage && userDetails.thumbImage !== "") ? userDetails.thumbImage : userDetails.image}
                            chatType="chat"
                        />
                    </span>
                    <span className="sender-name">
                        <span className="senderName">
                            {getSenderName(data)}
                            {isUserInactive(data?.publisherId) && (
                                <span className="inactive-user-tag">(Inactive user)</span>
                            )}
                        </span> <IconStaredArrow />{" "}
                        <span className="receiverName">
                            {getReceiverName(data)}
                            {isSingleChat(data?.chatType) &&
                                data?.fromUserId !== data?.publisherId &&
                                isUserInactive(data?.fromUserId) && (
                                    <span className="inactive-user-tag">(Inactive user)</span>
                                )}
                        </span>
                    </span>
                </div>
            </div>
        );
    };

    const downloadAction = async (event, file_url, fileName, fileKey, msgId) => {
        downloadMediaFile(msgId, file_url, "file", fileName, fileKey, event);
    };

    const getMessageElement = (data) => {
        const isSender = isLocalUser(data.publisherId);

        switch (data.msgType) {
            case "text":
            case "auto_text":
                return <TextComponent messageObject={data} isSender={isSender} handleShowCallScreen={handleShowCallScreen} isFromStarredMsg={true} />;

            case "meet":
                return <MeetComponent messageObject={data} isSender={isSender} handleShowCallScreen={handleShowCallScreen} />;

            case "image":
                return <ImageComponent messageObject={data} isSender={isSender} uploadStatus={2} imageHeightAdjust={true} imageUrlDownloaded={null} isImageDownloaded={true} />;

            case "video":
                return <VideoComponent messageObject={data} isSender={isSender} uploadStatus={2} imageHeightAdjust={true} />;

            case "audio":
                return <AudioComponent pageType={"starPage"} messageObject={data} isSender={!isSender} uploadStatus={2} audioUrlDownloaded={null} />;

            case "file":
                return (
                    <DocumentComponent
                        messageObject={data}
                        isSender={isSender}
                        uploadStatus={2}
                        downloadAction={downloadAction}
                    />
                );

            case "contact":
                return <ContactComponent messageObject={data} />;

            case "location":
                return <LocationComponent messageObject={data} />;

            case "channelInvitation": {
                const { msgBody: { channelInvitation } = {} } = data
                return <ChannelInvite messageObject={data} channelInvitation={channelInvitation} channelId={channelInvitation?.channelId} />;
            }

            default:
                return "";
        }
    };

    const handleDropDown = (event, idx) => {
        if (dropDownOpen) {
            setDropDownOpen(!dropDownOpen);
        }
        else {
            if (prevDropDownStatus === idx) {
                setDropDownStatus(idx);
                setPrevDropDownStatus('');
                setDropDownOpen(true);
            }
            else {
                event && event.stopPropagation();
                setDropDownStatus(idx);
                setPrevDropDownStatus(idx);
                setDropDownOpen(true);
            }
        }
    };

    const handleDropDownOutSideClick = (event, idx) => {
        if (dropDownOpen && dropDownStatus === idx) {
            setDropDownOpen(false)
        };
    };

    const unStarMessage = async (data) => {
        const storeData = Store.getState();
        const { recentChatData: { rosterData: { recentChatItems = [] } = {} } = {} } = storeData || {};
        const dataFind = recentChatItems.filter((ele) => ele.recent.fromUserId === data.fromUserId);
        if (dataFind.length >= 1 && dataFind[0]?.roster?.groupId != null && dataFind[0]?.roster?.isAdminBlocked) {
            return;
        }
        setDropDownStatus(-1);
        if (blockOfflineAction()) return;
        SDK.updateFavouriteStatus(data.fromUserJid, [data.msgId], false);
        toast.success(`1 message unstarred`);
    };

    const noUnstarMessages = () => {
        toast.info("There is no starred message.");
        setUnstarDrop(false);
    };

    const getMsgId = async (msgItem = {}) => jumpToMessage(msgItem, "starPage");

    const requestReplyMessage = (grmsgid, replyTo, chatType) => {
        if (isAppOnline()) {
            SDK.getReplyMessage(replyTo, chatType);
        } else {
            // When user try to reply in offline, at this time get the message
            // details from the local message history & set that message as reply message
            const message = getActiveConversationMessageByMsgId(replyTo, chatType);
            const replyMsgDetails = getReplyMessageFormat(message);
            if (replyMsgDetails) {
                Store.dispatch(ReplyMessageAction(replyMsgDetails));
            }
        }
    };

    const replayContentRender = (elememt = {}) => {
        const { fromUserJid = "", msgBody: { replyTo = "" } = {}, msgId = "", chatType = "" } = elememt;
        const newObj = getMessageFromHistoryById(fromUserJid, replyTo);
        if (_isEmpty(newObj)) {
            requestReplyMessage(msgId, replyTo, chatType);
        } else {
            offlineReplyHandle(newObj, replyTo);
        }
        const newArr = [...starredMessages];
        const findIndex = newArr.findIndex((ele) => _get(ele, "msgBody.replyTo") === _get(elememt, "msgBody.replyTo"));
        newArr[findIndex] = {
            ...newArr[findIndex],
            isReply: false,
        }
    }

    return (
        <Fragment>
            <div id={"star-msgContent"} className="staredMessages">
                <div>
                    <div className="contactlist">
                        <div className="recent-chatlist-header">
                            <div className="sub-heading-container">
                                <Button variant="ghost" onClick={handleBackToSetting} style={{
                                    height: '1.5rem',
                                    width: "1.5rem",
                                    padding: "0"
                                }} className="newchat-icon" title="Back"
                                    onKeyDown={(e) => e.key === 'Enter' && handleBackToSetting}
                                    tabIndex="0"
                                >
                                    <ArrowBackSettings />
                                </Button>
                                <span className='sub-heading'>Starred Messages</span>
                            </div>
                            {isStarMessageEnabled &&
                                <OutsideClickHandler onOutsideClick={() => setUnstarDrop(false)}>
                                    <div className="starMenu">
                                        <i>
                                            <IconStaredMenu onClick={() => setUnstarDrop(!unstarDrop)} />
                                        </i>
                                        {unstarDrop && (
                                            <ul className="menu-dropdown" style={{ padding: 0 }}>
                                                <li
                                                    title="Starred Messages"
                                                    onClick={starredMessages.length > 0 ? handleUnStarall : noUnstarMessages}
                                                    tabIndex={0}
                                                    role="button"
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            (starredMessages.length > 0 ? handleUnStarall : noUnstarMessages)();
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                >
                                                    <i>
                                                        <UnStar />
                                                    </i>
                                                    <span>Unstar all</span>
                                                </li>
                                            </ul>
                                        )}
                                    </div>
                                </OutsideClickHandler>
                            }
                        </div>

                        {isStarMessageEnabled && starredMessages.length > 0 && (
                            <ul className="staredContainer">
                                {starredMessages.map(
                                    (el, i) =>
                                        Object.keys(el).length > 0 && (
                                            <li
                                                className={`${getParentClass(el)}`} key={el.msgId}
                                                tabIndex="0"
                                                role="button"
                                            >
                                                {getProfileElement(el)}
                                                <div
                                                    className={`${getChildClass(el)}-row ${singleFileClass(el)}  ${singleFileClassLocation(el)} ${captionFinderClass(el)}`}
                                                >
                                                    {(_get(el, "isReply", false) === true) && replayContentRender(el)}
                                                    <div
                                                        onClick={() => getMsgId(el)}
                                                        onKeyDown={(e) => e.key === 'Enter' && getMsgId(el)}
                                                        className={`${getChildClass(el)} ${_get(el, "msgBody.replyTo", "") !== "" ? "reply-block" : ""} ${el.msgType}-message`}>
                                                        {_get(el, "msgBody.replyTo", "") !== "" &&
                                                            <ReplyMessageBlock
                                                                viewOriginalMessage={() => { }}
                                                                msgId={_get(el, "msgBody.replyTo", "")}
                                                                chatType={_get(el, "msgBody.chatType", "")}
                                                            />
                                                        }
                                                        {getMessageElement(el)}
                                                        {getMessageTimeElement(
                                                            getMsgStatusEle(el.msgStatus, el.seenReceipt, el.publisherId),
                                                            el.createdAt,
                                                            1,
                                                            !isLocalUser(el.publisherId),
                                                            el.msgType,
                                                            el.editedStatus
                                                        )}

                                                        <OutsideClickHandler onOutsideClick={(e) => handleDropDownOutSideClick(e, i)}>
                                                            <div className="message-dropdown-menu" onClick={(e) => handleDropDown(e, i)}
                                                                onKeyDown={(e) => e.key === 'Enter' && handleDropDown(e, i)}
                                                                tabIndex="0"
                                                                role="button" >
                                                                <span className="message-dropdown">
                                                                    <span className="actionDrop" ></span>
                                                                    <i>
                                                                        <Menu />
                                                                    </i>
                                                                </span>
                                                            </div>
                                                            {dropDownOpen && dropDownStatus === i && (
                                                                <ul className={`menu-dropdown open`} onClick={() => unStarMessage(el)}>
                                                                    <li className="Starred menu-dropdown-list-item" title="UnStarred"
                                                                        onKeyDown={(e) => e.key === 'Enter' && unStarMessage(el)}
                                                                        tabIndex="0"
                                                                        role="button"
                                                                    >
                                                                        <i>
                                                                            <UnStar />
                                                                        </i>
                                                                        <span>Unstar</span>
                                                                    </li>
                                                                </ul>
                                                            )}
                                                        </OutsideClickHandler>
                                                    </div>
                                                </div>
                                            </li>
                                        )
                                )}
                            </ul>
                        )}
                        {starredMessages.length === 0 && (
                            <div className="box-center h-full w-full flex-auto noStarredMessage">
                                <i>
                                    <IconNoStaredMessage />
                                    <IconNoStar className="star" />
                                </i>
                                <p>No Starred Messages</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {unstarConfirm && (
                <Modal containerId="container">
                    <div className="popup-wrapper deleteMessage">
                        <div className="popup-container">
                            <div className="popup-container-inner">
                                <div className="popup_close">
                                    <span>Are you sure you want to Unstar all messages?</span>
                                    <i onClick={() => setUnstarConfirm(false)}>
                                        <ClosePopup />
                                    </i>
                                </div>
                                <div className="popup-noteinfo">
                                    <Button variant="ghost" type="button" onClick={() => setUnstarConfirm(false)} className="btn-cancel">
                                        Cancel
                                    </Button>
                                    <Button varient="destructive" type="button" onClick={handleUnStarallAction} className="btn-active danger">
                                        Unstar all
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </Fragment>
    );
};

export default StarredMessages;

StarredMessages.propTypes = {
    handleBackToSetting: PropTypes.func,
    handleShowCallScreen: PropTypes.func,
    featureStateData: PropTypes.object,
};
